<template>
  <div class="shop-detail loader-container">
    <overlay-loader :loading="loading" />
    <template v-if="myStore">
      <div class="shop-detail__header flex flex-column">
        <div class="shop-detail__header-logo">
          <img
            :src="profilePic"
            class="shop-detail__header-image"
            alt="store-img"
          />
        </div>
        <div
          class="
            shop-detail__header-description
            shop-description shop-description-sm
          "
        >
          <div class="header-sm">
            <div class="shop-detail__header-title">
              <div class="shop-detail__header-name">{{ myStore.nombre }}</div>
              <div class="shop-detail__header-id text-align-xs">
                ({{ myStore["name-id-canonical"] }})
              </div>
            </div>
            <div class="header-sm">
              <div class="shop-detail__header-category">
                {{ myStore.categoria ? myStore.categoria.value : "-" }}
              </div>
              <div class="shop-detail__header-about text-align-xs">
                {{ myStore.descripcion }}
              </div>
              <div class="shop-detail__header-address text-align-xs">
                &#128204;
                {{ myStore.direccion }}
              </div>
            </div>
          </div>
          <div class="shop-detail__header-actions header-sm">
            <generate-qr :id="myStore.id" />
            <router-link
              target="_blank"
              :to="{
                name: 'invite.sellia',
                params: { id: myStore.id, client: 'demo' },
              }"
            >
              <hcc-button variant="transparent">
                <eye-icon />
                {{ $t("shop.view-as-visitor") }}
              </hcc-button>
            </router-link>

            <hcc-button @click="addProduct">
              {{ $t("shop.add-product") }}
            </hcc-button>
          </div>
        </div>
      </div>
      <div class="shop-detail__body" v-if="!showStatistics">
        <item-product
          v-for="product in products"
          :key="product.id"
          :data="product"
          class="flex-item flex-item-md flex-item-sm"
        >
          <template v-slot:footer>
            <div class="shop-detail__body-footer">
              <router-link
                :to="{
                  name: 'store.product-info',
                  params: {
                    idStore: $route.params.id,
                    idProduct: product.id
                  }
                }"
              >
                <hcc-button
                  variant="outline"
                  :size="buttonSize"
                >
                  {{ $t("shop.edit") }}
                </hcc-button>
              </router-link>
              <hcc-button
                variant="outline"
                color="accent"
                :size="buttonSize"
                @click="duplicate(product)"
              >
                {{ $t("shop.duplicate") }}</hcc-button
              >
              <hcc-button
                variant="outline"
                color="muted"
                :size="buttonSize"
                @click="deleteProduct(product)"
              >
                {{ $t("shop.delete") }}</hcc-button
              >
            </div>
          </template>
        </item-product>
      </div>
    </template>
    <hcc-confirmation />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import randomstring from 'randomstring';
import ItemProduct from '@/components/shop/ItemProduct.vue';
import OverlayLoader from '@/components/loaders/OverlayLoader.vue';
import HccConfirmation from '@/components/shared/HccConfirmation/index.vue';
import HccButton from '@/components/shared/HccButton/index.vue';
import GenerateQr from '@/components/shop/GenerateQr.vue';

export default {
  components: {
    ItemProduct,
    OverlayLoader,
    HccConfirmation,
    HccButton,
    GenerateQr,
  },
  data: () => ({
    edit: false,
    loading: false,
    actualPage: 1,
    currentStore: {},
    selectedProduct: null,
    showStatistics: false,
    showFormProduct: false,
  }),
  computed: {
    ...mapState({
      user: state => state.shared.user,
      myStore: state => state.shop.item,
      products: state => state.product.items,
      idProduct: state => state.product.idProduct,
    }),
    profilePic() {
      if (this.myStore.imageURL) {
        return this.myStore.imageURL;
      }

      return 'https://cdn2.iconfinder.com/data/icons/facebook-ui-colored/48/JD-15-512.png';
    },
    buttonSize() {
      return 'xs';
    },
    visits() {
      return this.$t('shop.statistics.visits');
    },
  },
  mounted() {
    this.loadStore();
  },
  watch: {
    '$route.params.id': function watchId(newState, oldState) {
      if (newState !== oldState) {
        this.loadStore();
      }
    },
  },
  methods: {
    ...mapActions({
      createProduct: 'product/save',
      duplicateProduct: 'product/duplicate',
      getSelectedStore: 'shop/getById',
      getAllProducts: 'product/getItems',
      removeProduct: 'product/remove',
    }),
    async saveProduct(producto) {
      this.loading = true;
      const newProduct = {
        ...producto,
        storeId: this.myStore.id,
      };
      await this.createProduct(newProduct);
      await this.getAllProducts(this.$route.params.id);
      this.loading = false;
    },
    cancelAddProduct() {
      this.showFormProduct = false;
      this.selectedProduct = null;
    },
    async duplicate(producto) {
      this.loading = true;
      const dataProducto = producto;
      delete dataProducto.id;
      this.loading = true;
      const newProduct = {
        ...producto,
        storeId: this.myStore.id,
      };
      await this.duplicateProduct(newProduct);
      this.loading = false;
    },
    addProduct() {
      this.$router.push({
        name: 'store.product-info',
        params: {
          idStore: this.$route.params.id,
          idProduct: randomstring.generate({ length: 20 }),
        },
      });
    },
    async removeAndGetProducts(id) {
      this.loading = true;
      await this.removeProduct(id);
      await this.getAllProducts(this.myStore.id);
      this.loading = false;
    },
    deleteProduct(product) {
      this.$modal.show('confirmation', {
        title: this.$t('shop.product.remove-product'),
        description: this.$t('shop.product.confirm-remove-product'),
        variant: 'default',
        confirm: () => this.removeAndGetProducts(product.id),
      });
    },
    async loadStore() {
      this.loading = true;
      await this.getSelectedStore(this.$route.params.id);
      await this.getAllProducts(this.$route.params.id);
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~styles/views/_store.scss";
</style>
